import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBottomDecoration = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 272,
	height: 386,
	viewBox: "0 0 272 386",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3310_9490)",
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 136,
				cy: 193,
				r: 148,
				stroke: "#DFCBF5",
				strokeOpacity: .7,
				strokeWidth: 1.05714,
				strokeLinecap: "round",
				strokeDasharray: "0.11 12.69"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 136,
				cy: 193,
				r: 192,
				stroke: "#DFCBF5",
				strokeOpacity: .4,
				strokeLinecap: "round",
				strokeDasharray: "0.1 12"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 136,
				cy: 193,
				r: 104,
				stroke: "#DFCBF5",
				strokeLinecap: "round",
				strokeDasharray: "0.1 12"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3310_9490",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 272,
			height: 386,
			fill: "white"
		})
	}) })]
});
export default SvgBottomDecoration;
